// #region Imports

/* Telestream */
import { ToFrames } from '@user-interface/timecode-utilities'
import { getTimecode } from './timecodes.utils';

// #endregion Imports

export function populateClipListMediaDefaults(context, model, schema) {
  const clonedSchema = JSON.parse(JSON.stringify(schema));
  
  if (model.clips && (model.clips.length > 0)) {
    const newestClip = model.clips[model.clips.length - 1];

    const clipProperties = clonedSchema.properties.clips.items.properties;

    if (clipProperties.path) {
      clipProperties.path.default = newestClip.path;
    }

    if (clipProperties.duration) {
      clipProperties.duration.default = newestClip.duration;
    }

    if (clipProperties.audioonly) {
      clipProperties.audioonly.default = newestClip.audioonly;
    }

    if (clipProperties.markin && context.rootState.video.inMarker) {
      const timecode = getCurrentTimeCode(context, context.rootState.video.inMarker);
      const frames = ToFrames(timecode);
      const marker = formatMarker(timecode, frames);
      clipProperties.markin.default = marker;
    }

    if (clipProperties.markout && context.rootState.video.outMarker) {
      const timecode = getCurrentTimeCode(context, context.rootState.video.outMarker);
      const frames = ToFrames(timecode);
      const marker = formatMarker(timecode, frames);
      clipProperties.markout.default = marker;
    }
  }

  return clonedSchema;
}

export function formatMarker(timecode, frame) {
  return `${timecode} [frame ${frame}]`;
}

function getCurrentTimeCode(context, time) {
  const element = context.rootState.video.element;
  const track = context.rootState.timeDisplaySource;

  return getTimecode(element, time, track);
}